import { useEffect, useRef } from 'react'

// Hook personalizado principalmente para cerrar el modal de perfil (ubicado en la esquina superior derecha)
// al hacer clic fuera de él, pero se puede usar en más casos si se necesita.
export default function useClickOutside(callbackFn) {
  const domNodeRef = useRef()
  const callbackRef = useRef(callbackFn)

  // Mantener la referencia actualizada sin recrear el listener
  useEffect(() => {
    callbackRef.current = callbackFn
  }, [callbackFn])

  useEffect(() => {
    const handler = (event) => {
      // Solo ejecutar si el ref está asignado y el clic fue fuera
      if (domNodeRef.current && !domNodeRef.current.contains(event.target)) {
        callbackRef.current()
      }
    }

    document.addEventListener('mousedown', handler)

    return () => {
      document.removeEventListener('mousedown', handler)
    }
  }, []) // Ahora sí podemos dejarlo vacío porque usamos callbackRef

  return domNodeRef
}